@if (data.isAvailable || data.editingAvailable) {
  <button title="{{ data.label !== undefined ? data.label : '' }}"  class="btn-with-icon-label ai-bot-icon" (click)="openModel()">
    <i class="fa"><img class="bot-icon nav-icon nav-img-icon ng-star-inserted" src="assets/images/icons/ai_1.svg"></i>
    <span class="ng-tns-c1655077576-1">AI Agent</span>
  </button>
}